<template>
  <nav id="mobile-navigation" class="c-nav-padding">
    <div class="fixed z-50 w-full bg-white border-b-2" :class="{ 'border-app-lime': !ikZoekBaas && !simpleMenu, 'border-app-green': ikZoekBaas || simpleMenu }">
      <div class="relative z-50 bg-white">
        <div class="mx-3 py-3">
          <div class="relative flex">
            <div class="flex place-items-center mr-3">
              <div>
                <AtomLink :url="homeUrl" title="Home">
                  <AtomBrandLogoMobile class="h-12" />
                </AtomLink>
              </div>
            </div>
            <div class="flex items-center ml-auto">
              <AtomButton v-if="cta && cta.url" id="mobile-navigation-btn-cta-donation" :url="cta.url" button-type="primary">
                <div class="flex place-items-center">
                  <div class="flex" :class="{ 'mr-4': cta.icon }">{{ cta.title }}</div>
                  <AtomIcon v-if="cta.icon" :icon="cta.icon.slug" class="text-black w-6 h-6 flex" />
                </div>
              </AtomButton>
              <AtomButton
                v-if="ikZoekBaas"
                id="mobile-navigation-btn-login"
                :aria-label="t_('account')"
                button-type="primary"
                class="ml-3"
                :url="userStore.hasUser ? { name: 'account-detail' } : { name: 'account-login' }"
              >
                <AtomIconPerson class="w-5 h-5 text-black" />
              </AtomButton>
              <AtomButton
                id="mobile-navigation-btn-open-menu"
                type="button"
                :aria-label="t_('menu')"
                button-type="secondary"
                class="ml-3 cursor-pointer"
                @click.prevent="overlayStore.setMobileMenu()"
              >
                <span class="app-clip">{{ t_('menu') }}</span>
                <AtomIcon :icon="overlayStore.mobileMenu ? 'x' : 'hamburger'" class="w-4 h-4 text-white" />
              </AtomButton>
            </div>
          </div>
        </div>
      </div>

      <div
        id="mobile-navigation-menu-panel"
        class="submenu-margins submenu-folded absolute z-10 bottom-0 left-0 px-3 w-full bg-white overflow-x-hidden overflow-y-scroll"
        :class="{ 'submenu-unfolded': overlayStore.mobileMenu }"
      >
        <div class="submenu-inner" :class="{ 'submenu-inner__unfolded': overlayStore.mobileMenu }">
          <!-- Mobile search -->
          <section v-if="!ikZoekBaas" id="mobile-navigation-search" class="justify-center px-5 py-6 border-b-2 border-app-gray sm:flex">
            <div class="relative sm:w-3/4 md:w-1/2">
              <input
                v-model="searchInput"
                type="text"
                :placeholder="t_('search-placeholder')"
                class="c-mobile-menu-search pl-6 pr-12 py-2 w-full text-base bg-app-green-100 border-0 border-transparent rounded"
                @keyup.enter="searchHandler"
              />
              <div class="absolute right-0 top-0 flex items-center justify-center w-12 h-full bg-app-lime rounded cursor-pointer">
                <AtomIconSearch class="w-4 h-4" @click.prevent="searchHandler" />
              </div>
            </div>
          </section>

          <div v-if="layers.layer2.currentId" class="flex mb-4 px-5 py-3 border-b-2 cursor-pointer" @click.prevent="reverse">
            <AtomMobileMenuBackButton :title="getPreviousName" />
          </div>

          <ul v-if="!simpleMenu" id="mobile-navigation-main-menu" class="mt-8">
            <li v-for="(value, index) in main" :key="index" class="mb-4 px-5">
              <div v-if="value.children && value.children.length && value.title" @click.prevent="addNextChildren(value.children, value.id, 2)">
                <MoleculeMobileMenuItem :title="value.title" class="font-bold" />
              </div>
              <div v-else>
                <MoleculeMobileMenuItem v-if="value.title" :title="value.title" :url="value.url" class="font-bold" />
              </div>
            </li>
          </ul>

          <ul v-if="simpleMenu" id="mobile-navigation-main-menu" class="mt-8">
            <li v-for="(value, index) in main" :key="index" class="mb-4 px-5">
              <MoleculeMobileMenuItem
                v-if="value.title && value.children.length"
                :title="value.title"
                :has-arrow="value.children.length > 0"
                @click.prevent="setSimpleMenuStatus(value.title)"
              />
              <MoleculeMobileMenuItem v-else-if="value.title && value.children.length === 0 && value.url" :title="value.title" :url="value.url" :has-arrow="false" />

              <ul v-if="value.children && value.children.length && value.title" v-show="simpleMenuStatus === value.title">
                <li v-for="(child, childIndex) in value.children" :key="childIndex" class="mb-4 ml-4">
                  <MoleculeMobileMenuItem v-if="child.title" :title="child.title" :url="child.url" :has-arrow="false" />
                </li>
              </ul>
            </li>
          </ul>

          <div class="px-1 sm:inline-flex">
            <div v-if="secondaryMenuTitle" class="w-full">
              <div class="flex items-start px-3 w-full">
                <AtomIcon icon="app-location-pin" :class="'shrink-0 w-5 h-5 text-app-green inline-block mr-1'" />
                <div class="text-sm leading-none">
                  {{ secondaryMenuTitle }}
                </div>
              </div>
            </div>
            <div v-if="te_('title')" class="flex items-start justify-start w-full" :class="{ flex: !secondaryMenuTitle, 'hidden sm:flex': secondaryMenuTitle }">
              <div class="flex items-start px-4 py-1 text-xs font-semibold bg-app-green-100 rounded-md uppercase">{{ t_('title') }}</div>
            </div>
          </div>

          <div id="mobile-navigation-service-menu" class="mt-6 border-t-2 border-app-gray" :class="{ 'py-6': service.length, 'py-3': !service.length }">
            <ul v-if="service.length">
              <li v-for="(value, key) in service" :key="key" class="mb-6 px-5 cursor-pointer">
                <AtomLink v-if="value.title" :url="value.url" :title="value.title">
                  <AtomIcon v-if="value.icon" :icon="value.icon.slug" class="inline-block mr-2 w-4" />
                  <span class="border-b-2 hover:border-app-green border-transparent"> {{ value.title }}</span>
                </AtomLink>
              </li>
            </ul>
            <AtomLink v-if="secondaryMenuTitle" url="/" :title="t_('home-label')" class="flex mb-4 mt-3 sm:inline-flex">
              <div class="flex items-center justify-center px-2 py-3 w-full text-sm bg-app-green-200 rounded-md">
                <AtomIcon icon="app-log-out" :class="'shrink-0 w-4 h-4 inline-block mr-2 text-app-green'" />
                <span>{{ t_('home-label') }}</span>
              </div>
            </AtomLink>
          </div>

          <!-- second layer -->
          <div
            id="mobile-navigation-submenu-panel"
            class="slide-menu absolute z-20 bottom-0 hidden px-3 bg-app-green-200"
            :class="{ 'slide-in': layers.layer2.status, 'slide-out': layers.layer2.shouldReverse }"
          >
            <template v-for="(child, childIndex) in main" :key="childIndex">
              <ul v-for="(innerChild, innerChildKey) in child.children" v-show="layers.layer2.currentId === child.id" :key="[childIndex, innerChildKey].join(':')" class="mt-4">
                <li>
                  <div v-if="innerChild.children && innerChild.children.length && innerChild.title" @click.prevent="addNextChildren(innerChild.children, innerChild.id, 3)">
                    <MoleculeMobileMenuItem :title="innerChild.title" />
                  </div>
                  <div v-else>
                    <MoleculeMobileMenuItem v-if="innerChild.title" :title="innerChild.title" :url="innerChild.url" />
                  </div>
                </li>
              </ul>
            </template>
          </div>

          <!-- third layer -->
          <div
            id="mobile-navigation-subsubmenu-panel"
            class="slide-menu absolute z-30 bottom-0 top-0 hidden px-3 bg-app-green-200"
            :class="{ 'slide-in': layers.layer3.status, 'slide-out': layers.layer3.shouldReverse }"
          >
            <template v-for="(child, childIndex) in main" :key="childIndex">
              <template v-for="(innerChild, innerKey) in child.children" :key="[childIndex, innerKey, innerKey].join(':')">
                <ul v-show="innerChild.id === layers.layer3.currentId" class="mt-4">
                  <template v-for="(innerInnerChild, innerInnerKey) in innerChild.children">
                    <li v-if="innerInnerChild.title" :key="innerInnerKey">
                      <div v-if="innerInnerChild.children && innerInnerChild.children.length" @click.prevent="addNextChildren(innerInnerChild.children, innerInnerChild.id)">
                        {{ innerInnerChild.title }}
                      </div>
                      <div v-else class="mb-4">
                        <MoleculeMobileMenuItem v-if="innerInnerChild.title" :title="innerInnerChild.title" :url="innerInnerChild.url" />
                      </div>
                    </li>
                  </template>
                </ul>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { getHomeUrl, setupSiteConfig } from '~/composables/craft'
import { setupTranslationPrefixer } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'
import { useOverlayStore } from '~/store/overlay'
import { useUserStore } from '~/store/user'

const route = useRoute()
const router = useRouter()
const navigationStore = useNavigationStore()
const overlayStore = useOverlayStore()
const userStore = useUserStore()
const { domain } = setupSiteConfig()
const { t_, te_ } = setupTranslationPrefixer('MobileMenu', domain)
const { url: homeUrl, simpleMenu, ikZoekBaas } = getHomeUrl(route)
const { main, service, secondaryMenuTitle, cta } = storeToRefs(navigationStore)
const layers = ref({
  layer2: {
    currentId: null,
    status: false,
    shouldReverse: false,
  },
  layer3: {
    currentId: null,
    status: false,
    shouldReverse: false,
  },
  layer4: {
    currentId: null,
    status: false,
    shouldReverse: false,
  },
})

const addNextChildren = (childrenList: any[], parent: any, layer: number) => {
  if (layer === 2) {
    layers.value.layer2.status = true
    layers.value.layer2.currentId = parent
  }

  if (layer === 3) {
    layers.value.layer3.status = true
    layers.value.layer3.currentId = parent
  }

  if (layer === 4) {
    layers.value.layer4.status = true
    layers.value.layer4.currentId = parent
  }
}

const reverse = () => {
  let done = false
  let objective

  if (!done && layers.value.layer4.status) {
    objective = 4
    layers.value.layer4.shouldReverse = true
    done = true
  }

  if (!done && layers.value.layer3.status) {
    objective = 3
    layers.value.layer3.shouldReverse = true
    done = true
  }

  if (!done && layers.value.layer2.status) {
    objective = 2
    layers.value.layer2.shouldReverse = true
    done = true
  }

  setTimeout(() => {
    layers.value[`layer${objective}`].status = false
    layers.value[`layer${objective}`].shouldReverse = false
    layers.value[`layer${objective}`].currentId = null
  }, 300)
}

const simpleMenuStatus = ref(null)
const setSimpleMenuStatus = (title: string) => {
  if (simpleMenuStatus.value === title) {
    simpleMenuStatus.value = null
    return
  }

  simpleMenuStatus.value = title
}

const getPreviousName = computed(() => {
  if (layers.value.layer4.status) {
    for (const child of main.value) {
      for (const innerChild of child.children) {
        if (innerChild.id === layers.value.layer3.currentId) {
          return innerChild.title
        }
      }
    }
  } else if (layers.value.layer3.status) {
    for (const child of main.value) {
      if (child.id === layers.value.layer2.currentId) {
        return child.title
      }
    }
  } else if (layers.value.layer2.status) {
    return 'Hoofdmenu'
  }
  return ''
})

function setupSearch() {
  const searchInput = ref('')
  const searchHandler = () => {
    router.push({ path: '/zoeken', query: { search: searchInput.value } })
  }
  return { searchHandler, searchInput }
}

const { searchHandler, searchInput } = setupSearch()
</script>

<style lang="scss" scoped>
.c-nav-padding {
  padding-bottom: 73px;
}

.submenu-margins {
  top: 74px;
}

.submenu-folded {
  height: 0;
  transition: 0.5s ease-in-out all;
}

.submenu-unfolded {
  height: calc(100vh - 70px);
}

.submenu-inner {
  display: none;

  &.submenu-inner__unfolded {
    display: block;
  }
}

.slide-menu {
  top: 162px;
}

.slide-in {
  display: block;
  min-width: 100%;
  animation: slideIn 0.25s linear;
  animation-fill-mode: forwards;
}

.slide-out {
  display: block;
  min-width: 100%;
  animation: slideOut 0.25s linear;
  animation-fill-mode: forwards;
}

@keyframes slideIn {
  0% {
    left: 100%;
  }
  100% {
    left: 0;
  }
}

@keyframes slideOut {
  0% {
    left: 0;
  }
  100% {
    left: 100%;
  }
}

.c-mobile-menu-search {
  height: 44px;
  box-shadow: 0 2px 0 theme('colors.app.gray');

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: theme('colors.black');
  }
}
</style>
